import PropTypes from 'prop-types';
import { BulkActions } from '../enums/bulk-actions';

export const BulkActionTypePropType = PropTypes.oneOf(Object.values(BulkActions).map((bulkAction) => bulkAction.name));

/**
 * @typedef {(
 *   'addNote'|
 *   'addTaxIdentifiers'|
 *   'applyShippingPreset'|
 *   'assignTo'|
 *   'confirmation'|
 *   'customFieldOne'|
 *   'customFieldTwo'|
 *   'customFieldThree'|
 *   'customsDeclarations'|
 *   'doNotNotifyMarketplace'|
 *   'emailTemplate'|
 *   'insurance'|
 *   'otherShippingOptions'|
 *   'packageBulkAction'|
 *   'packingSlipTemplate'|
 *   'service'|
 *   'shipByDate'|
 *   'shipFrom'|
 *   'shippingAccount'|
 *   'size'|
 *   'weight'|
 *   'adjustWeight'|
 *   'dutiesAndTaxes'
 * )} BulkActionType
 */
